import { render } from "./CartsView.vue?vue&type=template&id=09a5f099"
import script from "./CartsView.vue?vue&type=script&lang=js"
export * from "./CartsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__